import React from 'react';
import { Text, RichText, Image, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { AdsCard, AdsCardContent, AdsCtaLink } from '@arm/arm-design-system-react';
import './styles.css';
import '../SharedUtils/themeColors/backgroundColor.css';
import { addBackgroundColorVariables } from '../SharedUtils/themeColors';
import { addStyle, getTrackingAttributes } from '../SharedUtils/utils';
import RenderingStyling from '../../../lib/RenderingStyling';
import { useInvertedColor, useTheme } from '../SharedUtils/hooks';

const ImageAboveContentCard = ({ fields, rendering, sitecoreContext }) => {
  const isEditorMode = sitecoreContext.pageEditing;

  const { isLight } = useTheme();
  const isInverted = useInvertedColor(fields);

  const borderEnabled = fields.BorderEnabled?.value;

  const borderColor = isLight ? fields.borderColorLight?.value : fields.borderColorDark?.value;
  const borderHoverColor = isLight
    ? fields.borderHoverColorLight?.value
    : fields.borderHoverColorDark?.value;
  const borderRadius = fields.borderRadius?.value;

  const ctaLinkColor = isLight ? fields.ctaLinkColorLight?.value : fields.ctaLinkColorDark?.value;
  const ctaLinkHoverColor = isLight
    ? fields.ctaLinkHoverColorLight?.value
    : fields.ctaLinkHoverColorDark?.value;

  //Missing in AdsCtaLink config
  const ctaLinkVisitedColor = fields.ctaLinkVisitedColor?.value;

  const widgetStyles = {};
  const ctaStyleList = {};

  addBackgroundColorVariables(fields, widgetStyles);

  if (borderEnabled) {
    addStyle(widgetStyles, '--ads-card-border-width', '1px');
  }
  addStyle(widgetStyles, '--ads-card-border-color', borderColor);
  addStyle(widgetStyles, '--ads-card-border-color-hover', borderHoverColor);
  addStyle(widgetStyles, '--ads-card-content-padding', '0');
  addStyle(widgetStyles, '--ads-card-border-radius', borderRadius);
  addStyle(ctaStyleList, '--ads-cta-link-color', ctaLinkColor);
  addStyle(ctaStyleList, '--ads-cta-link-color-hover', ctaLinkHoverColor);

  const trackingAttributes = getTrackingAttributes(fields);

  return (
    <AdsCard
      {...RenderingStyling(rendering.componentName)}
      style={widgetStyles}
      className={
        'image-above-content-card-wrapper background-color-ads-card' +
        (borderEnabled ? ' is-border' : '') +
        (isInverted ? ' is-inverted' : '')
      }
    >
      <AdsCardContent slot="content">
        <div className={'o-widget c-image-above-content-card' + (isInverted ? ' is-inverted' : '')}>
          {(isEditorMode || (!isLight && fields?.Image?.value?.src)) && (
            <div className="c-image-above-content-card__image-placeholder">
              <Image className="c-image-above-content-card__image" media={fields?.Image} />
            </div>
          )}
          {isLight && fields?.ImageLight?.value?.src == null && fields?.Image?.value?.src && (
            <div className="c-image-above-content-card__image-placeholder">
              <Image className="c-image-above-content-card__image" media={fields?.Image} />
            </div>
          )}
          {(isEditorMode || (isLight && fields?.ImageLight?.value?.src)) && (
            <div className="c-image-above-content-card__image-placeholder">
              <Image className="c-image-above-content-card__image" media={fields?.ImageLight} />
            </div>
          )}
          {(isEditorMode || fields.FeatureHeading?.value) && (
            <h6
              tabIndex="0"
              className="c-image-above-content-card__feature u-text-lg-5 u-text-md-5 u-text-sm-5"
              data-component="Feature"
            >
              <RichText field={fields.FeatureHeading} />
            </h6>
          )}

          {(isEditorMode || fields.PrimaryHeading?.value) && (
            <h3
              tabIndex="0"
              className="c-image-above-content-card__primary u-text-lg-3 u-text-md-3 u-text-sm-3 u-text-bold-500"
              data-component="Primary"
            >
              <RichText field={fields.PrimaryHeading} />
            </h3>
          )}

          {(isEditorMode || fields.Description?.value) && (
            <div
              tabIndex="0"
              className="c-image-above-content-card__description u-text-body-lg u-text-body-md u-text-body-sm"
              data-component="Description"
            >
              <RichText field={fields.Description} />
            </div>
          )}

          {(isEditorMode || fields.CallToAction?.value?.href) && (
            <AdsCtaLink
              link={fields.CallToAction.value}
              srLabel={fields.CallToAction.value.title}
              style={ctaStyleList}
              {...trackingAttributes}
            >
              {fields.CallToAction.value.text}
            </AdsCtaLink>
          )}
        </div>
      </AdsCardContent>
    </AdsCard>
  );
};

export default withSitecoreContext()(ImageAboveContentCard);
